import React, { useContext, useEffect, useMemo, useRef } from 'react'
import axios from 'axios';
import Confetti from 'react-confetti'
import ContainerBackgroundWrapper from '../components/Backgrounds'
import CardWinnerProgressive from '../components/CardWinnerProgressive';
import useWindowSize from '../hooks/useWindowSize';
import { useParams, useNavigate } from 'react-router';
import { Apis } from '../util/Apis';
import { ContentButtons } from '../components/ButtonCustom';
import CustomLoading from '../components/CustomLoading';
import useGet from '../hooks/useGet';
import Button from '../components/atoms/Buttons';
import winnerSound from '../assets/sounds/winner.mp3';
import { isWinnerSoundMuted } from '../util/winnerSound';
import { SiteContext } from '../context/SiteContext';
import { getCurrencyConfig } from '../components/services';

const ProgressiveWinnerView = () => {
  const { id } = useParams();
  const size = useWindowSize();
  const navigate = useNavigate();
  const winnerAudioRef = useRef(null);
  const { currencyConfig: contextCurrencyConfig, salaId } = useContext(SiteContext);
  const currencyConfig = contextCurrencyConfig || getCurrencyConfig();

  const { loading, data } = useGet({
    url: Apis.TGM + '/progressive/' + id + '/detail',
    initialValue: { levels: [] }
  })

  const pozoWinner = useMemo(() => {
    if (!data?.levels?.length) return null

    return data.levels
      .filter((item) => item?.winner === true)
      .reduce((a, b) => (a.winnerDatetime > b.winnerDatetime ? a : b), 0)
  }, [data])

  const updateWinnerStatus = (status) => {
    const winnerId = pozoWinner?.progressiveLevelWinnerId
    if (!winnerId) return

    axios.put(`${Apis.TGM}/progressive-level-winner/${winnerId}/update-status`, {
      status,
    }).finally(() => {
      navigate(-1)
    })
  }

  useEffect(() => {
      if (isWinnerSoundMuted(salaId)) return;
      winnerAudioRef.current = new Audio(winnerSound);
      winnerAudioRef.current.play();
    }, [salaId]);

  return (
    <ContainerBackgroundWrapper showBackgroundCard={false}>
      {!loading && pozoWinner ?
        <>
          <Confetti
            width={size.width}
            height={size.height}
            opacity={0.8}
          />
          <CardWinnerProgressive
            name={pozoWinner.name}
            machine={pozoWinner.winnerMachineName}
            amount={pozoWinner.winAmount}
            currencySymbol={currencyConfig.symbol}
            winnerName={pozoWinner.winnerName}
            winnerDocument={pozoWinner.winnerDocument}
            winnerDocumentTypeName={pozoWinner.documentTypeName}
          />

          <ContentButtons>
            <Button style={{minWidth:"240px"}} variant="outline" onClick={() => updateWinnerStatus('CANCELLED')}>CANCELAR</Button>
            <Button style={{minWidth:"240px"}} onClick={() => updateWinnerStatus('PAID')}>CONFIRMAR</Button>
          </ContentButtons>
        </>
        :
        <CustomLoading />
      }
    </ContainerBackgroundWrapper>
  )
}

export default ProgressiveWinnerView
